import { mapWasteTypeKeyToIconName } from "helpers/wasteTypeIconKeyMapper";
import useDynamicSVGImport from "hooks/useDynamicSVGImport";

interface IWasteTypeCustomIconProps {
  id: string;
  wasteTypeId: string;
  onCompleted?: (
    name: string,
    SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> | undefined
  ) => void;
  onError?: (err: Error) => void;
}

const WasteTypeCustomIcon = (props: IWasteTypeCustomIconProps): any => {
  const assetPath : string = "assets/wasteTypeIcons";
  const {
    id, wasteTypeId, onCompleted, onError
  } = props;
  const wasteTypeIconName = mapWasteTypeKeyToIconName(wasteTypeId);
  const { error, loading, SvgIcon } = useDynamicSVGImport(wasteTypeIconName, assetPath, {
    onCompleted,
    onError
  });
  if (error) {
    return error.message;
  }
  if (loading) {
    return "Loading...";
  }
  if (SvgIcon) {
    return (
      <SvgIcon data-testid={`${id}-${wasteTypeId}-${wasteTypeIconName}`} />
    );
  }
  return null;
};

export default WasteTypeCustomIcon;
